// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {OrganizerCancellation} from 'redux/v1/organizerCancellation/models';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const FETCH_ORGANIZERCANCELLATION =
  'v1/organizerCancellation/FETCH_ORGANIZERCANCELLATION';
export const PUT_ORGANIZERCANCELLATION =
  'v1/organizerCancellation/PUT_ORGANIZERCANCELLATION';
export const DELETE_ORGANIZERCANCELLATION =
  'v1/organizerCancellation/DELETE_ORGANIZERCANCELLATION';

export type FetchOrganizerCancellationSuccess = ApiSuccess<
  OrganizerCancellation,
  *
>;

export const fetchOrganizerCancellationById = (
  journeyId: number,
  token: string
): any => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(FETCH_ORGANIZERCANCELLATION),
    callAPI: () =>
      axios
        .get(
          `${cfg.bookingServiceUrl}/organizercancellation/${journeyId}`,
          config
        )
        .then((res) => res.data.organizerCancellation),
  };
};

export const selectOrganizerCancellation = (
  journeyId: number,
  token: string,
  type: string
): any => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(PUT_ORGANIZERCANCELLATION),
    callAPI: () =>
      axios
        .put(
          `${cfg.bookingServiceUrl}/organizercancellation/${journeyId}`,
          {cancellation: type},
          config
        )
        .then((res) => res.data),
  };
};

export const deselectOrganizerCancellation = (
  journeyId: number,
  token: string
): any => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(DELETE_ORGANIZERCANCELLATION),
    callAPI: () =>
      axios
        .delete(
          `${cfg.bookingServiceUrl}/organizercancellation/${journeyId}`,
          config
        )
        .then((res) => res.data),
  };
};
